export enum AdminAddProgramFormItemLabel {
  Name = "Naziv programa",
  Description = "Opis programa",
  DropoutTimeInDays = "Vrijeme automatskog drop out-a (u danima)",
  MedicineOrHealthSupplement = "Lijek",
}
